<script setup lang="ts">
import { inject, type Ref } from 'vue'
import { useRouter } from 'vue-router'
import Title from '@/components/Title.vue'
import ContainerHeading from '@/components/Heading/ContainerHeading.vue'
import type { Container } from '@/models/Container'
import WarningMessage from '@/components/WarningMessage/WarningMessage.vue'

const router = useRouter()

const container = inject('container') as Ref<Container | null>

const cancel = () => {
  container.value = null
  router.replace({ name: 'move-container-container' })
}
const ok = () => {
  router.replace({ name: 'move-container-container', query: { sync: '1' } })
}
</script>

<template>
  <div class="page move-container-awaiting-weighing">
    <Title>Retirer / déposer un bac</Title>
    <ContainerHeading></ContainerHeading>
    <WarningMessage @ok="ok" @cancel="cancel">
      <template #message>Attention, l'état actuel de ce bac est : « EN ATTENTE DE PESÉE »</template>
      <template #question>Souhaitez-vous continuer ?</template>
    </WarningMessage>
  </div>
</template>
